<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-23 16:58:14
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 17:08:06
-->
<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 14:24:52
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 14:47:28
-->
<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {

            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询用户月票凭证",
                t_url: this.commonUrls.test + "getMonthTicketCertificateInfoList",
                p_url: this.commonUrls.prod + "getMonthTicketCertificateInfoList",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'carNo', info2: '是', info3: 'Integer', info4: '车牌号码' },
                        { info1: 'carNoColor', info2: '是', info3: 'String', info4: '车牌颜色：0其他，1蓝色，2黄色，3白色，4黑色，5绿色'},
                        { info1: 'telephone', info2: '否', info3: 'String', info4: '用户手机号码' },
                        { info1: 'ownerName', info2: '否', info3: 'String', info4: '车主名称'}
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' },
                    ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'vouchId', info2: '是', info3: 'String', info4: '凭证ID' },
                        { info1: 'parkCode', info2: '是', info3: 'Long', info4: '车场编码' },
                        { info1: 'parkName', info2: '否', info3: 'String', info4: '车场名称' },
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'ticketName', info2: '否', info3: 'String', info4: '月票名称' },
                        { info1: 'telephone', info2: '否', info3: 'String', info4: '手机号码' },
                        { info1: 'ownerName', info2: '否', info3: 'String', info4: '车主名称' },                        
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'carNoColor', info2: '否', info3: 'String', info4: '车牌颜色' },
                        { info1: 'submitTime', info2: '否', info3: 'String', info4: '提交时间' },
                        { info1: 'status', info2: '否', info3: 'Integer', info4: '状态' },
                        { info1: 'statusStr', info2: '否', info3: 'String', info4: '状态(文字表述)' },
                        { info1: 'type', info2: '否', info3: 'Integer', info4: '授权记录id' },
                        { info1: 'typeStr', info2: '否', info3: 'String', info4: '类型(文字表述)' },
                        { info1: 'expriedTime', info2: '否', info3: 'String', info4: '到期时间yyyyMMddHHmmss' },
                        { info1: 'checkTime', info2: '否', info3: 'String', info4: '审核时间yyyyMMddHHmmss' },
                        { info1: 'checkBy', info2: '否', info3: 'String', info4: '审核人' },
                        { info1: 'userId', info2: '否', info3: 'String', info4: '用户标识(openId或者unionId), 用于消息推送（新平台的停车场返回）' },
                        { info1: 'voucherAuditDetailList', info2: '否', info3: 'JSONArray', info4: '凭证审核明细列表' },
					   ]
                },{
                    titleName: 'voucherAuditDetailList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '凭证审核详细id（旧平台的, 此值为空）' },
                        { info1: 'voucherDetailId', info2: '是', info3: 'Long', info4: '凭证详细id（旧平台的, 此值为空）' },
                        { info1: 'resourceUrl', info2: '是', info3: 'String', info4: '凭证文件地址' },
                        { info1: 'reason', info2: '否', info3: 'String', info4: '原因' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '凭证状态 0=未审核，1=审核通过，2=审核不通过，3=审核过期' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketCertificateInfoList.vue